import { defineMessages } from "react-intl";

export const currencyCodes = defineMessages({
  CAD: { id: "currency-code.cad", defaultMessage: "Канадский доллар" },
  EUR: { id: "currency-code.eur", defaultMessage: "Евро" },
  KGS: { id: "currency-code.kgs", defaultMessage: "Кыргызский сом" },
  MULTI: {
    id: "bank-account.currency.MULTI",
    defaultMessage: "Мультивалютный счет",
  },
  RUB: { id: "currency-code.rub", defaultMessage: "Российский рубль" },
  USD: { id: "currency-code.usd", defaultMessage: "Доллар США" },
});
